import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import grass2000 from '../../assets/images/grass-2000.jpg';
import grass1500 from '../../assets/images/grass-1500.jpg';
import grass1000 from '../../assets/images/grass-1000.jpg';

const TopperWrapper = styled.div`
  width: 100%;
  background-color: var(--custom-green);
  background-image: url(${grass2000});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 8rem 0;
  margin-bottom: 6rem;
  @media (max-width: 1250px) {
    margin-bottom: 4rem;
    padding: 6rem 0;
  }
  @media (max-width: 900px) {
    background-image: url(${grass1500});
    margin-bottom: 2rem;
  }
  @media(max-width: 800px) {
    padding: 4rem 0;
    margin-bottom: 2rem;
  }
  @media (max-width: 600px) {
    padding: 2rem 0;
    background-image: url(${grass1000});
  }
  h1, h3 {
    color: white;
    width: calc(100% - 40px);
    max-width: 1000px;
    display: block;
    text-shadow: 0px 3px 8px rgba(33,33,33,0.75);
  }
  h1 {
    font-family: var(--block-font);
    margin: 0 auto;
    font-size: clamp(2rem, 9vw, 6rem);
    line-height: clamp(2.5rem, 10.5vw, 7rem);
    text-transform: uppercase;
    letter-spacing: 2px;
    @media (max-width: 800px) {
      letter-spacing: 0.5px;
    }
  }
  h3 {
    font-size: 1.5rem;
    font-size: clamp(1rem, 3vw, 1.5rem);
    margin: 0 auto 1rem;
    text-transform: uppercase;
  }
`;

const Topper = ({
  headline,
}) => (
  <TopperWrapper className="topper">
    <h3 className="benton-n6">The 2022 US Open</h3>
    <h1>{headline}</h1>
  </TopperWrapper>
);

Topper.propTypes = {
  headline: PropTypes.string.isRequired,
};

export default Topper;
